import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../context/AuthContext";
import { GeneralContext } from "../../../context/GeneralContext";
import { api } from "../../../utils/authActions";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import "./polling.scss";
import { Button } from "@mui/material";
import { formatDate, hasProperty } from "../../../utils/helpers";
//import toast from "react-hot-toast";

function PollSolver(props) {
  const { question, pollId, endDate, handleSolved } = props;
  const { authToken, isAuthReady } = useContext(AuthContext);
  const { recordedErrorLog } = useContext(GeneralContext);
  const [answers, setAnswers] = useState([]);
  const [selectedAnswer, setSelectedAnswer] = useState(null);

  useEffect(() => {
    if (isAuthReady) {
      // users: get possible answers for poll
      api
        .getPollAnswers(authToken, pollId)
        .then((response) => {
          setAnswers(response.data);
          setSelectedAnswer(null);
        })
        .catch((err) => {
          const errorDetails = hasProperty(err, "response")
            ? `Backend response: ${JSON.stringify(err.response, null, 2)}`
            : "No backend response available";
          recordedErrorLog(
            `THERE WAS AN ERROR WITH POLL ANSWERS: ${errorDetails}`,
            err,
            false,
            ""
          ); // no toats needed, but email should be sent
        });
    }
  }, [isAuthReady, pollId]);

  const handleSolve = () => {
    try {
      if (selectedAnswer !== null) {
        const payload = {
          poll_id: pollId,
          answer_local_id: selectedAnswer,
        };

        // users: give answer to poll
        api
          .answerPoll(authToken, payload)
          .then((response) => {
            console.log("answer to poll solve: ", response);
          })
          .catch((err) => {
            const errorDetails = hasProperty(err, "response")
              ? `Backend response: ${JSON.stringify(err.response, null, 2)}`
              : "No backend response available";
            recordedErrorLog(
              `THERE WAS AN ERROR WITH POLL RESPONSE: ${errorDetails}`,
              err,
              true,
              "Unexpected error occurred submitting the poll response. Please try again or contact support."
            );
          });

        handleSolved(pollId);
      }
    } catch (error) {
      recordedErrorLog("Solving handler failure: ", error);
    }
  };

  return (
    <div className="pollSolver"style={{ width: '90%', maxWidth: '500px' }}>
      <div className="question" style={{ backgroundColor: '#e3f2fd', borderRadius: '8px 8px 0 0', padding: '10px', margin: '-10px -10px 10px -10px' }}>{question}</div>
      {answers.length > 0 ? (
        <>
          <div className="allAnswersContainer">
            {answers.map((answer) => {
              return (
                <div className="answerArea" key={answer.answer_local_id}>
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={selectedAnswer === answer.answer_local_id}
                          onChange={() =>
                            setSelectedAnswer(answer.answer_local_id)
                          }
                        />
                      }
                      label={answer.answer}
                    />
                  </FormGroup>
                </div>
              );
            })}
          </div>
          <div className="solveButtonArea">
            <Button
              variant="contained"
              className="solveButton"
              onClick={() => handleSolve()}
              disabled={selectedAnswer === null}
            >
              Submit
            </Button>
          </div>
        </>
      ) : (
        <></>
      )}
      <div className="dateArea">
        <div className="title">Active till:</div>
        <div className="endDate">{formatDate(endDate)}</div>
      </div>
    </div>
  );
}

export default PollSolver;
